import React from "react";
import icon1 from "../../Images/industries-icon1.png";
import icon2 from "../../Images/industries-icon2.png";
import icon3 from "../../Images/industries-icon3.png";

const TrustAndSafetySection = () => {
  const items = [
    {
      title: "Insert Heading",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting",
      img: icon1,
    },
    {
      title: "Backed by insurance",
      text: "This platform services can be protected up to $1M for property damage.",
      img: icon2,
    },
    {
      title: "Anytime support",
      text: "Our Customer Success team is here for you and your pet 24/7.",
      img: icon3,
    },
  ];

  return (
    <section className="py-16 px-4 bg-[#A19784] text-center" data-aos="fade-up">
      <h2 className="text-4xl font-bold text-[#FFFFFF] mb-12">
        Trust and Safety
      </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
        {items.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-gray-800">
            <img
              src={item.img}
              alt={item.title}
              className="w-24 h-24 object-contain mb-4"
            />
            <h3 className="text-2xl font-semibold mb-2">{item.title}</h3>
            <p className="text-base text-gray-600">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustAndSafetySection;
